import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useState, useEffect } from "react";

function a11yProps(index) {
  return {
    id: `prize-tab-${index}`,
    "aria-controls": `prize-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`prize-tabpanel-${index}`}
      aria-labelledby={`prize-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const languages = [
  { title: "English", prefix: "en", index: 0 },
  { title: "French", prefix: "fr", index: 1 },
];

export default function PrizeEditModal({
  open,
  onClose,
  prize,
  onSave,
  prizeDrawParams,
  prizeLoading,
}) {
  const [lang, setLang] = useState(0);
  const [editedPrize, setEditedPrize] = useState(prize || {});

  useEffect(() => {
    if (prize) {
      setEditedPrize(prize);
    }
  }, [prize]);

  const handleChangeTabs = (event, newLang) => {
    setLang(newLang);
  };

  const handleFieldChange = (field, value) => {
    setEditedPrize((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    onSave(editedPrize);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Prize</DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", mt: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={lang}
              onChange={handleChangeTabs}
              aria-label="prize language tabs"
            >
              {languages.map(({ title, index }) => (
                <Tab key={index} label={title} {...a11yProps(index)} />
              ))}
            </Tabs>
          </Box>
          {languages.map(({ prefix, index }) => (
            <TabPanel value={lang} index={index} key={prefix}>
              <Stack spacing={3}>
                <TextField
                  label="Title"
                  fullWidth
                  value={editedPrize[`title_${prefix}`] || ""}
                  placeholder={`Title Prize (${prefix.toUpperCase()})`}
                  onChange={(e) =>
                    handleFieldChange(`title_${prefix}`, e.target.value)
                  }
                />
                <TextField
                  label="Description"
                  fullWidth
                  multiline
                  rows={4}
                  value={editedPrize[`description_${prefix}`] || ""}
                  placeholder={`Description Prize (${prefix.toUpperCase()})`}
                  onChange={(e) =>
                    handleFieldChange(`description_${prefix}`, e.target.value)
                  }
                />
              </Stack>
            </TabPanel>
          ))}
          <Box sx={{ mt: 3 }}>
            <TextField
              label="Tickets"
              fullWidth
              type="number"
              value={editedPrize.tickets || ""}
              placeholder="Enter Tickets"
              onChange={(e) => handleFieldChange("tickets", e.target.value)}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={prizeLoading}
        >
          {prizeDrawParams ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
